import { compose } from 'recompose';

import PaymentView from './PaymentView';

export default compose()(PaymentView);
